<template>
  <div class="settings-loc-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Utilization Status</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        @click="addStatus"
        variant="primary"
      >
        New
      </b-button>
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="utilizationStatuses"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="true"
    ></grid>
    <b-modal
      centered
      ref="form-modal"
      :title="formId ? 'Edit Status' : 'Add Status'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submit"
      no-close-on-backdrop
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button class="bg-med-light-gray" variant="light" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-form-group
        label="Name"
        :state="formErrors.name.length == 0 ? null : false"
        :invalid-feedback="formErrors.name.join(', ')"
      >
        <b-form-input
          v-model="form.name"
          maxLength="100"
          :state="formErrors.name.length == 0 ? null : false"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Color">
        <color-picker v-model="form.color" />
      </b-form-group>
      <b-form-group label="Order">
        <b-form-input
          v-model.number="form.position"
          type="number"
          :placeholder="'0'"
        ></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import ColorPicker from "../controls/ColorPicker.vue";
import urStatusServer from "../../server/urStatus";
import { mapActions, mapState } from "vuex";
import { validateRequired } from "../../helpers/validation";

export default {
  name: "UrStatusCrud",
  components: {
    Grid,
    ColorPicker
  },
  data() {
    return {
      formId: undefined,
      form: {
        name: "",
        color: "",
        position: 0
      },
      formErrors: {
        name: []
      }
    };
  },
  mounted() {
    this.fetchUtilizationStatuses();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("client", ["fetchUtilizationStatuses"]),
    validateSubmit() {
      let withoutErrors = true;

      this.formErrors.name = [];
      if (!validateRequired(this.form.name)) {
        this.formErrors.name.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submit(modalEvent) {
      modalEvent.preventDefault();
      this.form.position = this.form.position || 0;
      const result = this.validateSubmit();
      if (result) {
        const formData = {
          ...this.form
        };
        if (this.formId) {
          await urStatusServer.update(this.formId, formData);
        } else {
          await urStatusServer.create(formData);
        }
        this.fetchUtilizationStatuses();
        this.showAlertSuccess();
        this.$refs["form-modal"].hide();
      }
    },
    addStatus() {
      this.formId = undefined;
      this.form = {
        name: "",
        color: "#16aaff",
        position: 0
      };
      this.formErrors = {
        name: [],
        position: []
      };
      this.$refs["form-modal"].show();
    }
  },
  computed: {
    ...mapState("client", {
      utilizationStatuses: state => state.utilizationStatuses
    }),
    columns() {
      let columns = [
        {
          text: "Name",
          field: "name",
          width: 300,
          sortable(a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
          }
        },
        {
          text: "Color",
          field: "color",
          type: "template",
          width: 70,
          align: "center",
          template: data => {
            return `<div class="d-flex w-100 justify-content-center"><div class="small-square" style="background-color:${
              data.record.data.color ? data.record.data.color : "black"
            };"></div></div>`;
          },
          sortable: false
        },
        {
          text: "Order",
          field: "position",
          width: 100,
          align: "center"
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "end",
          width: 70,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.formId = record.id;
                this.form = {
                  ...record.data
                };
                this.formErrors = {
                  name: [],
                  position: []
                };
                this.$refs["form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await urStatusServer.delete(record.id);
                    this.fetchUtilizationStatuses();
                    this.showAlertSuccess();
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
      return columns;
    }
  }
};
</script>

<style>
.settings-loc-container .b-grid-container .b-container {
  max-height: calc(100vh - 281px);
}
</style>
